export default function WhyChooseUs() {
  const benefits = [
    {
      icon: 'ri-robot-line',
      title: 'AI-Powered Development',
      description: 'We use AI to build websites faster and smarter than traditional agencies — cutting costs and timelines without cutting quality.',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Nashville Local Experts',
      description: 'We understand Nashville businesses. From East Nashville boutiques to Franklin law firms — we build sites that speak to your local market.',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Live in Days, Not Months',
      description: 'Get your Nashville business online quickly. Most sites launch within days — not the months you\'d wait at a traditional web agency.',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Honest, Affordable Pricing',
      description: 'Transparent pricing starting at $1,000 — designed specifically for Nashville small businesses with no surprise fees.',
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Built to Rank Locally',
      description: 'Every site we build is optimized for local search so Nashville customers can find you on Google when they\'re ready to buy.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Fully Managed & Secure',
      description: 'Professional hosting, SSL security, daily backups, and guaranteed uptime. We handle the tech so you run your business.',
    },
  ];

  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="why-choose-us" className="py-20 lg:py-32 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-20">
          <div className="inline-block px-4 py-2 bg-white/5 border border-white/10 rounded-full mb-6">
            <span className="text-sm text-gray-300 font-medium">Why Nashville Businesses Choose Us</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-6">
            Why Choose GWDevelopers for Web Design in Nashville
          </h2>
          <p className="text-base sm:text-xl text-gray-400 max-w-3xl mx-auto">
            We combine <strong className="text-white">AI web development</strong> with local Nashville expertise to deliver websites that look great, load fast, and rank in search — at a price that works for small businesses.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8 mb-12 lg:mb-16">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-gray-900/50 border border-white/10 rounded-2xl p-6 sm:p-10 hover:bg-gray-900 hover:border-white/20 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border-2 border-white/20 rounded-full mb-5 sm:mb-6">
                <i className={`${benefit.icon} text-lg sm:text-xl text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white mb-3">{benefit.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        {/* Trust bar */}
        <div className="border border-white/10 rounded-2xl p-6 sm:p-8 bg-gray-900/30">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 text-center">
            <div>
              <div className="text-3xl sm:text-4xl font-bold text-white mb-2">24 hrs</div>
              <div className="text-xs sm:text-sm text-gray-400">Average preview turnaround</div>
            </div>
            <div>
              <div className="text-3xl sm:text-4xl font-bold text-white mb-2">$1,000</div>
              <div className="text-xs sm:text-sm text-gray-400">Starting price — no hidden fees</div>
            </div>
            <div>
              <div className="text-3xl sm:text-4xl font-bold text-white mb-2">99.9%</div>
              <div className="text-xs sm:text-sm text-gray-400">Uptime guarantee</div>
            </div>
            <div>
              <div className="text-3xl sm:text-4xl font-bold text-white mb-2">Nashville</div>
              <div className="text-xs sm:text-sm text-gray-400">Proudly serving Middle TN</div>
            </div>
          </div>
        </div>

        <div className="text-center mt-10 sm:mt-12">
          <button
            onClick={scrollToContact}
            className="px-8 sm:px-10 py-4 bg-white text-black font-bold rounded-lg hover:bg-gray-200 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Get a Free Demo Website
          </button>
        </div>
      </div>
    </section>
  );
}
